module.exports = __webpack_public_path__ + "static/media/disconnect-blue.6a45cafc.svg";